import Link from 'next/link';
import { useRouter } from 'next/router';

import { IFacetOption } from 'shared/types/ConstructorFacet';
import { getFiltersQuery } from 'search/utils/getFiltersQuery';

interface ISearchFilterLink {
  children: React.ReactNode;
  facetType: string;
  option: IFacetOption;
}

export const SearchFilterLink = ({ children, facetType, option }: ISearchFilterLink) => {
  const { pathname, query } = useRouter();

  return (
    <Link
      href={{
        pathname,
        query: getFiltersQuery(query, facetType, option),
      }}
      key={option.display_name}
      passHref
      prefetch={false}
      scroll
      shallow
    >
      {children}
    </Link>
  );
};
